<template>

<app-panel v-on:close="$emit('close')" class="preview">
            
    <app-panel-content :slim="true" :grow="true">
    
        <app-panel-title text="Activity Audit" :is-big="true" />

        <app-panel-summary label="User" :value="userText" />

        <app-panel-summary label="Date" :value="item.date | localDate('MM/DD/YYYY h:mma')" />
    
        <app-panel-text class="subactivities">

            <div class="subactivities-item is-first" v-html="actionText(item)" />

            <div v-for="(subactivity, index) in item.subactivities" :key="index" class="subactivities-item" v-html="actionText(subactivity)" />

        </app-panel-text>

    </app-panel-content>
    
</app-panel>
    
</template>
    
<script>
    
export default {

    props: ['item'],

    methods: {

        actionText: function(action) {
        
            var text = action.text 
            var object = []

            text = '<b>' + ((action.user) ? action.user.name : 'System') + '</b> ' + text.charAt(0).toLowerCase() + text.slice(1)

            object.push('<b>' + action.data.name + '</b>')

            text = text.replace('{{object}}', object.join(''))

            text = text.replace('{{type}}', this.$constants.activity.typeName[action.type].toLowerCase())

            if(action.context === this.$constants.activity.context.updated) {

                var changes = this.$_.keys(action.data.changes)
            
                text = text + ' with ' + changes.length.toString() + ' change' + ((changes.length === 1) ? '' : 's')

            }

            return text
        
        }

    },

    computed: {

        userText: function() {
        
            if (this.item.badge) {
            
                return this.item.badge.name
            
            } else if (this.item.user) {
            
                return this.item.user.name
            
            } else {
            
                return 'System'
            
            }
        
        }
    
    }
    
}
    
</script>

<style scoped>
    
.preview {
    display: flex;
    flex-direction: column;
}

.subactivities {
    padding: 10px 0px 0px 0px;
}

.subactivities-item {
    padding: 5px 20px;
}

.subactivities-item >>> b:first-of-type {
    font-weight: 300!important;
}

.subactivities-item >>> b:last-of-type {
    font-weight: 400!important;
}

.subactivities-item.is-title {
    color: #fff;
    font-weight: 500;
}

.subactivities-item.is-first {
    color: #fff;
    font-weight: 500;
}

.subactivities-item:not(.is-first):not(.is-title) {
    padding-left: 40px;
    line-height: 16px;
}

.subactivities-item:not(.is-first):not(.is-title):before {
    height: 1px;
    content: '';
    width: 10px;
    background-color: rgba(255, 255, 255, 0.25);
    position: absolute;
    display: block;
    left: 24px;
    top: 50%;
}

.subactivities-item:not(.is-first):not(.is-title):after {
    height: 8px;
    content: '';
    width: 1px;
    background-color: rgba(255, 255, 255, 0.25);
    position: absolute;
    display: block;
    left: 24px;
    top: calc(50% - 8px);
}

</style>